import styled, { css } from 'styled-components';
import { Colors } from '@blueprintjs/core';

export const SideBar = styled.div.attrs(props => ({
    //width: props.width || '48px',
    darkMode: props.darkMode || false,
    darkBgColor: Colors.LIGHT_GRAY5,
    lightBgColor: Colors.DARK_GRAY5,
}))`
    display: flex;
    flex-direction: column;
    //align-items: center;
    //width: 4px;
    
    ${props => props.darkMode && css`
        background-color: ${props.darkBgColor+'33'};
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: ${props.darkBgColor+'80'};
            transition: all 0.2s ease-in-out;
            //width: ${props.width};
        }
    `}
    ${props => !props.darkMode && css`
        background-color: ${props.lightBgColor+'33'};
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: ${props.lightBgColor+'80'};
            transition: all 0.2s ease-in-out;
            //width: ${props.width};
        }
    `}
`;
